import e from "./CopyLinkButton.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/components/CopyLinkButton.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=CopyLinkButton.vue.js.map